(() => {
  'use strict';

  const PROFILES = {
    fiber_laser: [
      ['Laser power', ['power-', 'laser-power-']],
      ['Working area', ['size-', 'working-size-', 'table-size-']],
      ['Machine design', ['design-', 'configuration-', 'feature-', 'phase-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ],
    tube_laser: [
      ['Laser power', ['power-', 'laser-power-']],
      ['Profile capacity', ['capacity-', 'diameter-', 'tube-size-', 'profile-size-']],
      ['Stock length', ['length-', 'stock-length-', 'size-']],
      ['Loading system', ['loading-', 'loader-', 'configuration-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ],
    laser_welding: [
      ['Laser power', ['power-', 'laser-power-']],
      ['Welding process', ['process-', 'weld-']],
      ['Materials', ['material-']],
      ['Configuration', ['configuration-', 'feature-', 'wire-feeder-']],
      ['Production duty', ['duty-']]
    ],
    laser_cleaning: [
      ['Laser power', ['power-', 'laser-power-']],
      ['Cleaning process', ['process-', 'application-']],
      ['Operating mode', ['mode-', 'configuration-', 'feature-']],
      ['Base material', ['material-']],
      ['Production duty', ['duty-']]
    ],
    press_brake: [
      ['Tonnage', ['capacity-', 'tonnage-']],
      ['Bend length', ['size-', 'length-', 'working-length-']],
      ['Axis package', ['axis-', 'axes-']],
      ['Controller', ['control-', 'controller-']],
      ['Material capability', ['material-']],
      ['Production duty', ['duty-']]
    ],
    forming: [
      ['Machine type', ['process-', 'machine-', 'configuration-']],
      ['Working width', ['size-', 'width-', 'length-']],
      ['Capacity', ['capacity-', 'tonnage-', 'thickness-']],
      ['Control & automation', ['control-', 'automation-', 'axis-']],
      ['Production duty', ['duty-']]
    ],
    saw: [
      ['Cutting capacity', ['capacity-', 'size-', 'diameter-']],
      ['Saw type', ['process-', 'machine-', 'configuration-']],
      ['Miter capability', ['miter-', 'angle-']],
      ['Automation', ['automation-', 'control-', 'feed-']],
      ['Material capability', ['material-']],
      ['Production duty', ['duty-']]
    ],
    welding_robotics: [
      ['Welding process', ['process-', 'weld-']],
      ['Robot & system type', ['robot-', 'cobot-', 'machine-', 'configuration-']],
      ['Payload & reach', ['payload-', 'reach-', 'capacity-', 'size-']],
      ['Cell configuration', ['positioner-', 'cell-', 'track-', 'feature-']],
      ['Production duty', ['duty-']]
    ],
    cnc_mill: [
      ['Axis configuration', ['axis-', 'axes-']],
      ['Travel & work envelope', ['travel-', 'size-', 'capacity-']],
      ['Spindle & taper', ['spindle-', 'taper-', 'power-']],
      ['Control', ['control-', 'controller-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ],
    cnc_lathe: [
      ['Turning capacity', ['diameter-', 'turning-', 'capacity-']],
      ['Turning length', ['length-', 'size-', 'travel-']],
      ['Bar & chuck capacity', ['bar-', 'chuck-', 'spindle-']],
      ['Control', ['control-', 'controller-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ],
    plasma: [
      ['Power & amperage', ['power-', 'amperage-']],
      ['Table size', ['size-', 'table-size-', 'working-size-']],
      ['Torch & process', ['torch-', 'process-', 'configuration-']],
      ['Machine design', ['design-', 'feature-']],
      ['Production duty', ['duty-']]
    ],
    waterjet: [
      ['Pressure & pump', ['pressure-', 'power-', 'pump-']],
      ['Table size', ['size-', 'table-size-', 'working-size-']],
      ['Cutting head & axes', ['head-', 'axis-', 'axes-']],
      ['Control & automation', ['control-', 'automation-']],
      ['Production duty', ['duty-']]
    ],
    structural_tube: [
      ['Process & machine type', ['process-', 'machine-', 'configuration-']],
      ['Profile capacity', ['capacity-', 'diameter-', 'size-']],
      ['Stock length', ['length-', 'stock-length-']],
      ['Control & automation', ['control-', 'automation-', 'axis-']],
      ['Production duty', ['duty-']]
    ],
    production_forming: [
      ['Process & line type', ['process-', 'machine-', 'configuration-']],
      ['Capacity', ['capacity-', 'tonnage-', 'thickness-']],
      ['Working width & size', ['size-', 'width-', 'length-']],
      ['Control & automation', ['control-', 'automation-', 'axis-']],
      ['Production duty', ['duty-']]
    ],
    finishing: [
      ['Finishing process', ['process-', 'application-']],
      ['Working capacity', ['capacity-', 'size-', 'width-']],
      ['Media & method', ['media-', 'method-', 'configuration-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ],
    handling: [
      ['Equipment type', ['machine-', 'process-', 'configuration-']],
      ['Load capacity', ['capacity-', 'load-', 'payload-']],
      ['Size & reach', ['size-', 'reach-', 'height-', 'length-']],
      ['Automation', ['automation-', 'control-', 'feature-']],
      ['Production duty', ['duty-']]
    ],
    utilities: [
      ['Equipment type', ['machine-', 'process-', 'configuration-', 'application-']],
      ['Power & capacity', ['power-', 'capacity-', 'hp-', 'kw-']],
      ['Electrical service', ['voltage-', 'phase-', 'amperage-']],
      ['Flow & output', ['cfm-', 'flow-', 'kva-', 'pressure-']],
      ['Production duty', ['duty-']]
    ],
    parts_tooling: [
      ['Part family', ['part-', 'component-', 'consumable-', 'tooling-', 'product-']],
      ['Machine compatibility', ['machine-', 'compatibility-', 'category-']],
      ['Size & specification', ['size-', 'capacity-', 'power-', 'model-']],
      ['Brand', ['brand-', 'vendor-']],
      ['Condition', ['condition-']]
    ],
    technical: [
      ['Service type', ['service-', 'process-', 'application-']],
      ['Machine family', ['machine-', 'category-', 'compatibility-']],
      ['Software & control', ['software-', 'control-', 'controller-']],
      ['Delivery method', ['delivery-', 'support-', 'configuration-']]
    ],
    lines: [
      ['Process & line type', ['process-', 'line-', 'machine-', 'configuration-']],
      ['Capacity & output', ['capacity-', 'output-', 'speed-', 'power-']],
      ['Material', ['material-']],
      ['Automation & control', ['automation-', 'control-', 'axis-']],
      ['Production duty', ['duty-']]
    ],
    generic: [
      ['Machine type', ['machine-', 'process-', 'configuration-']],
      ['Capacity & power', ['capacity-', 'power-', 'tonnage-', 'diameter-']],
      ['Working size', ['size-', 'length-', 'width-', 'travel-']],
      ['Control & automation', ['control-', 'controller-', 'automation-', 'axis-']],
      ['Materials', ['material-']],
      ['Production duty', ['duty-']]
    ]
  };

  const ACRONYMS = new Map([
    ['cnc', 'CNC'], ['nc', 'NC'], ['mig', 'MIG'], ['tig', 'TIG'], ['plc', 'PLC'],
    ['hmi', 'HMI'], ['cad', 'CAD'], ['cam', 'CAM'], ['cfm', 'CFM'], ['kva', 'kVA'],
    ['kw', 'kW'], ['hp', 'HP'], ['psi', 'PSI'], ['od', 'OD'], ['id', 'ID'],
    ['ac', 'AC'], ['dc', 'DC'], ['co2', 'CO₂'], ['ipg', 'IPG'], ['boci', 'BOCI']
  ]);

  const handleize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, '-and-')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const humanize = (tag, prefix, facetLabel) => {
    let value = String(tag || '').slice(prefix.length).replace(/[_-]+/g, ' ').trim();
    value = value
      .replace(/(\d)\s*x\s*(\d)/gi, '$1 × $2')
      .replace(/(\d+)\s*(ft|in|mm|cm|kw|hp|kva|cfm|psi|v|a|w)\b/gi, '$1 $2');

    const words = value.split(/\s+/).filter(Boolean).map((word) => {
      const normalized = word.toLowerCase();
      if (ACRONYMS.has(normalized)) return ACRONYMS.get(normalized);
      if (/^\d+(\.\d+)?$/.test(word)) return word;
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    });

    value = words.join(' ');
    if (/axis/i.test(facetLabel) && /^\d+(\.\d+)?$/.test(value)) value = `${value}-axis`;
    return value || String(tag).replace(/[_-]+/g, ' ');
  };

  const track = (event, details) => {
    if (!window.UmproThemeConfig?.analyticsEnabled) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  };

  const mergeCurrentQuery = (href) => {
    const target = new URL(href, window.location.origin);
    const current = new URL(window.location.href);
    current.searchParams.forEach((value, key) => {
      if (!target.searchParams.has(key)) target.searchParams.append(key, value);
    });
    target.searchParams.delete('page');
    return target;
  };

  const replaceFacetTag = (root, tag, activeTags) => {
    const url = new URL(window.location.href);
    const marker = `/collections/${root.dataset.smfCollectionHandle}`;
    const index = url.pathname.indexOf(marker);
    if (index < 0) return null;

    const baseEnd = index + marker.length;
    const basePath = url.pathname.slice(0, baseEnd);
    const tail = url.pathname.slice(baseEnd).replace(/^\/+/, '');
    const remove = new Set(activeTags.map(handleize));
    const tags = tail
      ? tail.split('+').map((item) => decodeURIComponent(item)).filter((item) => !remove.has(handleize(item)))
      : [];

    tags.push(handleize(tag));
    url.pathname = `${basePath}/${[...new Set(tags)].join('+')}`;
    url.searchParams.delete('page');
    return url;
  };

  const createCustomFacets = (root) => {
    const container = root.querySelector('[data-smf-custom-facets]');
    const sourceNodes = [...root.querySelectorAll('[data-smf-tag-source] [data-smf-tag]')];
    if (!container || !sourceNodes.length) return 0;

    const profile = PROFILES[root.dataset.smfProfile] || PROFILES.generic;
    const assigned = new Set();
    let groupCount = 0;

    profile.forEach(([label, prefixes], facetIndex) => {
      const items = [];

      sourceNodes.forEach((node) => {
        const raw = node.dataset.smfTag || '';
        const lower = raw.toLowerCase();
        if (!raw || assigned.has(raw)) return;

        const prefix = prefixes.find((candidate) => lower.startsWith(candidate));
        if (!prefix) return;

        const href = node.dataset.smfTagUrl || '';
        if (!href) return;

        assigned.add(raw);
        items.push({
          raw,
          prefix,
          active: node.dataset.smfTagActive === 'true',
          href,
          label: humanize(raw, prefix, label)
        });
      });

      const activeItems = items.filter((item) => item.active);
      if (items.length < 2 && !activeItems.length) return;

      items.sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));

      const details = document.createElement('details');
      details.className = 'smf-facet';
      details.dataset.smfCustomGroup = label;
      if (activeItems.length || facetIndex === 0) details.open = true;

      const summary = document.createElement('summary');
      const title = document.createElement('span');
      title.textContent = label;
      const count = document.createElement('span');
      count.className = 'smf-facet__count';
      count.textContent = String(activeItems.length);
      summary.append(title, count);

      const options = document.createElement('div');
      options.className = 'smf-options';

      items.forEach((item) => {
        const link = document.createElement('a');
        link.className = `smf-option smf-option--link${item.active ? ' is-active' : ''}`;
        link.href = mergeCurrentQuery(item.href).href;
        link.dataset.smfTagOption = item.raw;
        if (item.active) link.setAttribute('aria-current', 'true');

        const value = document.createElement('span');
        value.textContent = item.label;
        const state = document.createElement('small');
        state.textContent = item.active ? 'Selected' : '';

        link.append(value, state);
        link.addEventListener('click', (event) => {
          event.preventDefault();

          let destination;
          if (item.active) {
            destination = mergeCurrentQuery(item.href);
          } else if (activeItems.length) {
            destination = replaceFacetTag(root, item.raw, activeItems.map((active) => active.raw));
          } else {
            destination = mergeCurrentQuery(item.href);
          }

          if (!destination) destination = mergeCurrentQuery(item.href);
          destination.searchParams.delete('page');

          track('collection_filter_change_v1', {
            collection_handle: root.dataset.smfCollectionHandle,
            filter_group: label,
            filter_value: item.raw,
            filter_action: item.active ? 'remove' : 'add'
          });

          window.location.assign(destination.href);
        });

        options.append(link);
      });

      details.append(summary, options);
      container.append(details);
      groupCount += 1;
    });

    return groupCount;
  };

  const prepareNativeGroups = (root) => {
    let visible = 0;
    root.querySelectorAll('[data-smf-native-group]').forEach((group) => {
      const usable = [...group.querySelectorAll('input')].some((input) => !input.disabled);
      if (!usable) {
        group.hidden = true;
        return;
      }
      visible += 1;
    });
    return visible;
  };

  const placeInterface = (root, hasFilters, nativeCount) => {
    const panel = root.querySelector('[data-smf-panel]');
    const toolbar = root.querySelector('[data-smf-toolbar]');
    const active = root.querySelector('[data-smf-active]');
    const layout = document.querySelector('.gold-collection__layout');
    const guide = layout?.querySelector('.gold-collection__guide');
    const records = layout?.querySelector('.gold-collection__records');
    const recordsHeader = records?.querySelector('.gold-collection__records-header');

    if (!records) {
      root.hidden = true;
      root.classList.add('smf-ready');
      return;
    }

    if (hasFilters && guide && panel) guide.prepend(panel);
    if (!hasFilters && panel) panel.hidden = true;

    if (toolbar) {
      if (recordsHeader) recordsHeader.insertAdjacentElement('afterend', toolbar);
      else records.prepend(toolbar);

      if (active) toolbar.insertAdjacentElement('afterend', active);
    }

    const openButton = toolbar?.querySelector('[data-smf-open]');
    if (!hasFilters && openButton) openButton.hidden = true;

    if (nativeCount === 0 && panel) {
      const apply = panel.querySelector('.smf-panel__actions button');
      const reset = panel.querySelector('.smf-panel__actions a');
      if (apply) apply.hidden = true;
      if (!reset) panel.querySelector('.smf-panel__actions')?.setAttribute('hidden', 'hidden');
    }

    root.classList.add('smf-ready');
  };

  const bindForm = (root) => {
    const form = root.querySelector('[data-smf-native-form]');
    if (!(form instanceof HTMLFormElement)) return;

    let submitTimer = 0;
    form.querySelectorAll('[data-smf-auto-submit]').forEach((control) => {
      control.addEventListener('change', () => {
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(() => form.requestSubmit(), 140);
      });
    });

    const sort = root.querySelector('[data-smf-sort]');
    sort?.addEventListener('change', () => form.requestSubmit());

    form.addEventListener('submit', () => {
      track('collection_filter_submit_v1', {
        collection_handle: root.dataset.smfCollectionHandle,
        profile: root.dataset.smfProfile
      });
    });
  };

  const bindDrawer = (root) => {
    const panel = root.querySelector('[data-smf-panel]');
    const overlay = root.querySelector('[data-smf-overlay]');
    const open = root.querySelector('[data-smf-open]');
    const close = root.querySelector('[data-smf-close]');
    if (!panel || !overlay || !open) return;

    const mobileQuery = window.matchMedia('(max-width: 980px)');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const syncAccessibility = (isOpen = panel.classList.contains('is-open')) => {
      if (!mobileQuery.matches) {
        panel.removeAttribute('inert');
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        return;
      }
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.toggleAttribute('inert', !isOpen);
      panel.setAttribute('aria-hidden', String(!isOpen));
    };

    const setOpen = (isOpen) => {
      panel.classList.toggle('is-open', isOpen);
      overlay.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('smf-lock', isOpen);
      open.setAttribute('aria-expanded', String(isOpen));
      syncAccessibility(isOpen);
      if (isOpen) close?.focus();
      else open.focus();
    };

    open.setAttribute('aria-expanded', 'false');
    syncAccessibility(false);
    open.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    overlay.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        setOpen(false);
        return;
      }
      if (event.key !== 'Tab' || !mobileQuery.matches || !panel.classList.contains('is-open')) return;
      const focusable = [...panel.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) {
        panel.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.classList.remove('smf-lock');
        open.setAttribute('aria-expanded', 'false');
      }
      syncAccessibility(false);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-smf-root]').forEach((root) => {
      const customCount = createCustomFacets(root);
      const nativeCount = prepareNativeGroups(root);
      const hasFilters = customCount + nativeCount > 0;

      bindForm(root);
      bindDrawer(root);
      placeInterface(root, hasFilters, nativeCount);

      track('collection_filter_view_v1', {
        collection_handle: root.dataset.smfCollectionHandle,
        profile: root.dataset.smfProfile,
        custom_filter_groups: customCount,
        native_filter_groups: nativeCount
      });
    });
  }, { once: true });
})();
